import cuid from "cuid";
import uuidv4 from "uuid/v4";
import packageJson from "../../../package.json";

import { APP_NAME } from "../../config";
import { getSubject } from "./tokenFunc";
const appVersion = packageJson.version;

export function createHttpHeaderWithAuthorization(
  jwtToken,
  correlationId = uuidv4(),
  managerId = localStorage.getItem("selectedAccountantID"),
  itemId = localStorage.getItem("selectedClientID"),
  language = "it-IT"
) {
  const httpHeader = createHttpHeader(
    correlationId, managerId, itemId, language
  );
  httpHeader["Authorization"] = `Bearer ${jwtToken}`;
  httpHeader["X-User-ID"] = getSubject(jwtToken);
  return httpHeader;
}

export function createHttpHeader(
  correlationId = uuidv4(), managerId, itemId, language = "it-IT"
) {
  return {
    "X-App-Name": APP_NAME,
    "X-App-Version": appVersion,
    "X-Request-ID": cuid(),
    "X-Correlation-ID": correlationId,
    "X-Item-ID": itemId || "",
    "X-Manager-ID": managerId || "",
    "Content-Type": "application/json;charset=utf-8",
    Accept: "application/json;charset=utf-8",
    "Accept-Language": language
  };
}

export function createHttpHeaderForB2bCert(language="it-IT"){
  return {
    "Content-Type": "application/json;charset=utf-8",
    Accept: "application/json;charset=utf-8",
    "Accept-Language": language
  };
}
